import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ContactFields } from "@/components/sponsorship/SponsorEnquiryForm";

const EMPTY = { contact_name: "", company: "", email: "", phone: "" };

export const SponsorPayDialog = ({ pkg, onClose, onSubmit }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  if (!pkg) return null;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await onSubmit(f);
    setBusy(false);
  };

  return (
    <Dialog open={!!pkg} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="sponsor-pay-dialog" className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display uppercase tracking-tight">{pkg.name} Sponsorship · ${Number(pkg.price_cad).toLocaleString("en-CA")} CAD</DialogTitle>
          <DialogDescription>Tell us who's sponsoring, then you'll pay securely by card on the next screen.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <ContactFields f={f} set={set} prefix="pay" />
          <button data-testid="pay-continue" disabled={busy}
            className="w-full bg-[#E63946] hover:bg-[#D90429] text-white px-5 py-3 text-sm font-semibold uppercase tracking-wider rounded-sm disabled:opacity-60">
            {busy ? "Opening secure checkout…" : "Continue to Payment"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
